import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingPageComponent } from './pages/booking/booking.page';
import { TimeSlotListComponent } from './components/time-slot-list/time-slot-list.component';
import { TicketCountComponent } from './components/ticket-count/ticket-count.component';
import { TimeLengthSelectorComponent } from './components/time-length-selector/time-length-selector.component';
import { ProductTimeSpanComponent } from './components/product-time-span/product-time-span.component';
import { ProductTimeSpansComponent } from './components/product-time-spans/product-time-spans.component';
import { UpDownComponent } from './components/up-down/up-down.component';
import { ProductPackComponent } from './components/product-pack/product-pack.component';
import { ProductComponent } from './components/product/product.component';
import { TicketConfiguratorComponent } from './components/ticket-configurator/ticket-configurator.component';
import { TicketAdvancedConfiguratorComponent } from './components/ticket-advanced-configurator/ticket-advanced-configurator.component';
import { TableSelectComponent } from './components/table-select/table-select.component';
import { Routes, RouterModule } from '@angular/router';
import { GeneralModule } from './../general/general.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BookingService } from './services/booking.service';
import { environment } from '../../../environments/environment';
import { BookingOdooService } from './services/booking-odoo.service';
import { BookingInMemoryService } from './services/booking-in-memory.service';
import { HttpClientModule } from '@angular/common/http';
import { BookingPacksComponent } from './components/booking-packs/booking-packs.component';
import { BookingSlotsComponent } from './components/booking-slots/booking-slots.component';
import { BookingSlotsGuard } from './guards/booking-slots.guard';
import { BookingProductsComponent } from './components/booking-products/booking-products.component.page';
import { BookingAdvancedProductsComponent } from './components/booking-advanced-products/booking-advanced-products.component';
import { BookingOrderComponent } from './components/booking-order/booking-order.component';
import { BookingOrderGuard } from './guards/booking-order.guard';
import { BookingAdvancedProductsGuard } from './guards/booking-advanced-products.guard';
import { BookingLoginGuard } from './guards/booking-login.guard';
import { BookingRegisterGuard } from './guards/booking-register.guard';
import { OrderModule } from '../order/order.module';
import { LabelWithIconComponent } from './components/label-with-icon/label-with-icon.component';
import { BookingSlotStateService } from './services/booking-slot-state.service';
import { LoginModule } from '../login/login.module';
import { PartnerModule } from '../partner/partner.module';
import { PaymentModule } from '../payment/payment.module';
import { BookingEventsProductsComponent } from './components/booking-events-products/booking-events-products.component';
import { MaterialModule } from '../../material.module';
import { BookingSingleProductsGuard } from './guards/booking-single-products.guard';
import { BookingEventProductsGuard } from './guards/booking-event-products.guard';
import { EventConfiguratorComponent } from './components/event-configurator/event-configurator.component';
import { FormsModule } from '@angular/forms';
import { BookingAreaItemPackComponent } from './components/booking-area-item-pack/booking-area-item-pack.component';
import { BookingPacksHomeComponent } from './components/booking-packs-home/booking-packs-home.component';
import { ProductInfoPopupComponent } from './components/product-info-popup/product-info-popup.component';
import { BookingBasketSimpleViewComponent } from './components/booking-basket-simple-view/booking-basket-simple-view.component';
import { BookingContactUsComponent } from './components/booking-contact-us/booking-contact-us.component';
import { BookingOrderService } from './services/booking-order.service';
import { TimeSlotDiagramComponent } from './components/time-slot-diagram/time-slot-diagram.component';
import { TimeSlotNavigationComponent } from './components/time-slot-navigation/time-slot-navigation.component';
import { TimeSlotEventListComponent } from './components/time-slot-event-list/time-slot-event-list.component';
import { BookingEventPacksComponent } from './components/booking-event-packs/booking-event-packs.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BookingGroupEventComponent } from './components/booking-group-event/booking-group-event.component';
import { BookingGroupEventThankYouComponent } from './components/booking-group-event-thank-you/booking-group-event-thank-you.component';
import { BookingRouterComponent } from './components/booking-router/booking-router.component';
import { SalePriceScheduleService } from './services/sale-price-schedule.service';
import { SalePriceScheduleOdooService } from './services/sale-price-schedule-odoo.service';
import { SalePriceScheduleInMemoryService } from './services/sale-price-schedule-in-memory.service';
import { SalePriceScheduleStateService } from './services/sale-price-schedule-state.service';
import { TimeRestrictionService } from './services/time-restriction.service';
import { BookingBuyMoreComponent } from './components/booking-buy-more/booking-buy-more.component';
import { BookingOrderTitleComponent } from './components/booking-order-title/booking-order-title.component';
import { BookingEventPacksGuard } from './guards/booking-event-packs.guard';
import { BookingEventsAreaItemSlotComponent } from './components/booking-events-area-item-slot/booking-events-area-item-slot.component';
import { BookingEventAreaItemSlotComponent } from './components/booking-event-area-item-slot/booking-event-area-item-slot.component';
import { BookingEventSlotProductsGuard } from './guards/booking-event-slot-products.guard';
import { BookingEventAreaItemSlotProductsComponent } from './components/booking-event-area-item-slot-products/booking-event-area-item-slot-products.component';
import { BookingEventSlotProductComponent } from './components/booking-event-slot-product/booking-event-slot-product.component';
import { BookingBreadcrumbsService } from './services/booking-breadcrumbs.service';
import { BookingProductConfigurationPageComponent } from './components/booking-product-configuration-page/booking-product-configuration-page.component';
import { BookingProductConfigurationFormComponent } from './components/booking-product-configuration-form/booking-product-configuration-form.component';
import { BookingSingleProductConfigurationGuard } from './guards/booking-single-product-configuration.guard';
import { BookingCapacityService } from './services/booking-capacity.service';
import { AccessControlPopupComponent } from './components/access-control-popup/access-control-popup.component';
import { PartnerCodeModule } from '../partner-code/partner-code.module';
import { TimeSlotSimpleListComponent } from './components/time-slot-simple-list/time-slot-simple-list.component';
import { TimeSlotSelectorComponent } from './components/time-slot-selector/time-slot-selector.component';
import { RemoveOrderQuestionPopupComponent } from './components/remove-order-question-popup/remove-order-question-popup.component';
import { BookingAuthenticationComponent } from './components/booking-authentication/booking-authentication.component';
import { BookingsGuard } from './guards/booking.guard';
import { BookingProductStepService } from './services/booking-product-step.service';
import { BookingProductOrderComponent } from './components/booking-product-order/booking-product-order.component';
import { BookingProductPageComponent } from './pages/booking-products/booking-product.page';
import { BookingProductAuthenticationComponent } from './components/booking-product-authentication/booking-product-authentication.component';
import { BookingProductOrderGuard } from './guards/booking-product-order.guard';
import { NavigationService } from './services/navigation.services';
import { ProductCategoryComponent } from './components/product-category/product-category.component';
import { BookingProductAuthnGuard } from './guards/booking-product-auth.guard';

const routes: Routes = [
  {
    path: 'booking',
    component: BookingPageComponent,
    canActivate: [BookingsGuard],
    data: {
      title: ['Ticket'],
    },
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: BookingPacksComponent,
            data: {
              title: ['Ticket'],
              breadcrumb: { title: 'What', sequence: 0, url: '/booking' }
            },
          },
          {
            path: 'slots',
            component: BookingSlotsComponent,
            canActivate: [BookingSlotsGuard],
            data: {
              title: ['Select Your Ticket'],
              breadcrumb: { title: 'When', sequence: 1, url: '/booking/slots' }
            },
          },
          {
            path: 'single',
            children: [
              {
                path: 'product',
                children: [
                  {
                    path: '',
                    component: BookingProductsComponent,
                    canActivate: [BookingSingleProductsGuard],
                    data: {
                      title: ['Select Your Persons'],
                      breadcrumb: { title: 'Who', sequence: 2, url: '/booking/single/product' }
                    },
                  },
                  {
                    path: 'configuration',
                    component: BookingProductConfigurationPageComponent,
                    canActivate: [BookingSingleProductConfigurationGuard],
                    data: {
                      title: ['Select Your Persons'],
                      breadcrumb: { title: 'Who', sequence: 2, url: '/booking/single/product/configuration' }
                    },
                  }
                ]
              },
            ]
          },
          {
            path: 'event',
            children: [
              {
                path: '',
                component: BookingEventPacksComponent,
                canActivate: [BookingEventPacksGuard],
                data: {
                  title: ['Events'],
                  breadcrumb: { title: 'What', sequence: 0, url: '/booking/event' }
                },
              },
              {
                path: 'slots',
                component: BookingSlotsComponent,
                canActivate: [BookingSlotsGuard],
                data: {
                  title: ['Select Your Ticket'],
                  breadcrumb: { title: 'When', sequence: 1, url: '/booking/event/slots' }
                },
              },
              {
                path: 'product',
                component: BookingEventsProductsComponent,
                canActivate: [BookingEventProductsGuard],
                data: {
                  title: ['Select Your Birthday'],
                  breadcrumb: { title: 'Who', sequence: 2, url: '/booking/event/product' }
                },
              },
            ]
          },
          {
            path: 'events',
            children: [
              {
                path: '',
                component: BookingEventsAreaItemSlotComponent,
                // canActivate: [BookingEventsAreaItemSlotGuard],
                data: {
                  title: ['Events'],
                  breadcrumb: { title: 'What', sequence: 0, url: '/booking/events' }
                },
              },
              {
                path: 'product',
                component: BookingEventAreaItemSlotProductsComponent,
                canActivate: [BookingEventSlotProductsGuard],
                data: {
                  title: ['Select Your Persons'],
                  breadcrumb: { title: 'When', sequence: 1, url: '/booking/events/product' }
                },
              },
            ]
          },
          {
            path: 'products',
            children: [
              {
                path: 'select-products',
                component: BookingProductOrderComponent,
                canActivate: [BookingProductOrderGuard],
                data: { title: ['Select Products'] },
              },
              {
                path: 'configuration',
                component: BookingProductConfigurationPageComponent,
                canActivate: [BookingSingleProductConfigurationGuard],
                data: { title: ['Select Your Persons'] },
              },
              {
                path: 'authentication',
                component: BookingProductAuthenticationComponent,
                canActivate: [BookingProductAuthnGuard],
                data: { title: ['Authentication'] },
              },
              {
                path: '',
                component: BookingProductPageComponent,
                data: { title: ['Products'] },
              },
            ]
          },
          {
            path: 'advanced-product',
            component: BookingAdvancedProductsComponent,
            canActivate: [BookingAdvancedProductsGuard],
          },
          {
            path: 'order',
            component: BookingOrderComponent,
            canActivate: [BookingOrderGuard],
            data: {
              title: ['Basket'],
              breadcrumb: { title: 'Payment', sequence: 4, url: '/booking/order' }
            },
          },
          {
            path: 'authentication',
            component: BookingAuthenticationComponent,
            canActivate: [BookingOrderGuard],
            data: { title: ['authentication'] },
          },
          {
            path: 'login',
            component: BookingOrderComponent,
            canActivate: [BookingLoginGuard],
            data: { title: ['Login'] },
          },
          {
            path: 'register',
            component: BookingOrderComponent,
            canActivate: [BookingRegisterGuard],
            data: { title: ['Register'] },
          },
          {
            path: 'group-event',
            component: BookingGroupEventComponent,
            data: { title: ['Group event'] },
          },
          {
            path: 'contact-thank-you',
            component: BookingGroupEventThankYouComponent,
            data: { title: ['Thank You'] },
          },
          {
            path: '**',
            redirectTo: '/booking',
            pathMatch: 'full'
          },
        ]
      },
    ]
  },
  {
    path: 'event/:eventPackName',
    component: BookingRouterComponent,
    data: {
      title: ['Event'],
    },
  },
  {
    path: 'ticket/:productPackName',
    component: BookingRouterComponent,
    data: {
      title: ['Ticket'],
    },
  },
];

const bookingServiceClass = environment.production ? BookingOdooService : BookingInMemoryService;
const salePriceScheduleServiceClass = environment.production ? SalePriceScheduleOdooService : SalePriceScheduleInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    HttpClientModule,
    FontAwesomeModule,
    RouterModule.forChild(routes),
    MaterialModule,
    GeneralModule,
    OrderModule,
    LoginModule,
    PartnerModule,
    PaymentModule,
    PartnerCodeModule,
  ],
  declarations: [
    BookingProductConfigurationPageComponent,
    BookingPageComponent,
    TimeSlotListComponent,
    TicketCountComponent,
    TimeLengthSelectorComponent,
    ProductPackComponent,
    ProductComponent,
    ProductCategoryComponent,
    TableSelectComponent,
    BookingSlotsComponent,
    BookingProductsComponent,
    BookingPacksComponent,
    UpDownComponent,
    ProductTimeSpanComponent,
    ProductTimeSpansComponent,
    TicketConfiguratorComponent,
    TicketAdvancedConfiguratorComponent,
    BookingAdvancedProductsComponent,
    BookingOrderComponent,
    LabelWithIconComponent,
    BookingEventsProductsComponent,
    EventConfiguratorComponent,
    BookingAreaItemPackComponent,
    BookingPacksHomeComponent,
    ProductInfoPopupComponent,
    BookingBasketSimpleViewComponent,
    BookingContactUsComponent,
    TimeSlotDiagramComponent,
    TimeSlotNavigationComponent,
    TimeSlotEventListComponent,
    BookingEventPacksComponent,
    BookingGroupEventComponent,
    BookingGroupEventThankYouComponent,
    BookingRouterComponent,
    BookingBuyMoreComponent,
    BookingOrderTitleComponent,
    BookingEventsAreaItemSlotComponent,
    BookingEventAreaItemSlotComponent,
    BookingEventAreaItemSlotProductsComponent,
    BookingEventSlotProductComponent,
    BookingProductConfigurationFormComponent,
    AccessControlPopupComponent,
    TimeSlotSimpleListComponent,
    TimeSlotSelectorComponent,
    RemoveOrderQuestionPopupComponent,
    BookingAuthenticationComponent,
    BookingProductOrderComponent,
    BookingProductPageComponent,
    BookingProductAuthenticationComponent,
  ],
  providers: [
    BookingsGuard,
    BookingSlotsGuard,
    BookingSingleProductsGuard,
    BookingEventProductsGuard,
    BookingAdvancedProductsGuard,
    BookingOrderGuard,
    BookingLoginGuard,
    BookingRegisterGuard,
    BookingSlotStateService,
    BookingEventPacksGuard,
    [{ provide: BookingService, useClass: bookingServiceClass }],
    BookingOrderService,
    [{ provide: SalePriceScheduleService, useClass: salePriceScheduleServiceClass }],
    SalePriceScheduleStateService,
    TimeRestrictionService,
    BookingEventSlotProductsGuard,
    BookingBreadcrumbsService,
    BookingCapacityService,
    BookingProductStepService,
    BookingProductOrderGuard,
    BookingProductAuthnGuard,
    NavigationService,
  ],
  exports: [
    BookingPacksHomeComponent,
    BookingAreaItemPackComponent,
    TimeSlotListComponent,
    EventConfiguratorComponent,
    BookingBasketSimpleViewComponent,
    TicketAdvancedConfiguratorComponent,
  ],
  entryComponents: [
    ProductInfoPopupComponent,
    AccessControlPopupComponent,
    RemoveOrderQuestionPopupComponent,
  ]
})
export class BookingModule { }
